var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",staticStyle:{"background-color":"#ffffff","background-image":"linear-gradient(315deg, #ffffff 0%, #cea177 74%)"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }